import { Link, useNavigate } from 'react-router-dom';
import { Plus, Receipt } from 'lucide-react';
import { useCondoContext } from '@/features/auth/use-condo-context';
import { useGastosComunes } from '@/features/gastos-comunes/api';
import { GastosTable } from '@/features/gastos-comunes/gastos-table';
import { Button } from '@/components/ui/button';
import { EmptyState } from '@/components/common/empty-state';
import { PageContainer } from '@/components/common/page-container';
import { PageHeader } from '@/components/common/page-header';

export function GastosComunesListRoute() {
  const { condoId } = useCondoContext();
  const { data, isLoading } = useGastosComunes(condoId);
  const navigate = useNavigate();
  const items = data?.items ?? [];

  return (
    <PageContainer>
      <PageHeader
        eyebrow="Finanzas · Emision"
        title="Gastos comunes"
        subtitle="Historial de emisiones y su estado de cobro. Cada prorrateo se calcula por alicuota de unidad."
        action={
          <Button asChild>
            <Link to={`/app/condominios/${condoId}/gastos-comunes/nuevo`}>
              <Plus className="h-4 w-4" />
              Nuevo gasto comun
            </Link>
          </Button>
        }
      />

      {items.length === 0 && !isLoading ? (
        <EmptyState
          icon={<Receipt className="h-5 w-5" />}
          title="Aun no se emite ningun gasto comun"
          description="Crea un borrador del gasto comun del periodo. Podras revisarlo y emitirlo cuando estes listo."
          action={
            <Button asChild>
              <Link to={`/app/condominios/${condoId}/gastos-comunes/nuevo`}>Crear borrador</Link>
            </Button>
          }
        />
      ) : (
        <GastosTable
          data={items}
          isLoading={isLoading}
          onRowClick={(g) => navigate(`/app/condominios/${condoId}/gastos-comunes/${g.id}`)}
        />
      )}
    </PageContainer>
  );
}
